import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { HubEndpoint } from '../../constants/hub-endpoint';
import { API_URL } from '../../../../../../services/config';
import { HubLoanerPhoneListItem, HubLoanerPhoneListSearchCriteria } from '../../models/hub-loaner-phones.model';
import { getQueryStringFromObject } from '../../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class HubLoanerPhoneListService {
  constructor(private http: WrapperHttpService) {}

  getLoanerPhoneList({
    hubId,
    searchCriteria,
  }: {
    hubId: number;
    searchCriteria: HubLoanerPhoneListSearchCriteria;
  }): Observable<HubLoanerPhoneListItem[]> {
    const url =
      `${API_URL}${HubEndpoint.Base}/${hubId}${HubEndpoint.LoanerPhones}?` + getQueryStringFromObject(searchCriteria);

    return this.http.withLoading().get<HubLoanerPhoneListItem[]>(url);
  }
}
